/**
 * Converts px values to rems based on 16px base font-size
 *
 * @param {number} pixels - px value
 * @returns {string} rem value
 */
const rems = (pixels) => `${(pixels / 16).toFixed(3)}rem`;

export default rems;
